import { Component, Input } from '@angular/core';

export type WaitTimeTypes =
  | 'live'
  | 'asyncSupport'
  | 'asyncChe'
  | 'hil'
  | 'noop';

@Component({
  selector: 'cigna-omni-messaging-wait-time',
  templateUrl: './wait-time.component.html',
  styleUrls: ['./wait-time.component.scss'],
})
export class OmniMessagingWaitTimeComponent {
  @Input()
  public datetime: string;
  @Input()
  public footer: string;
  @Input()
  public lineOne: string;
  @Input()
  public lineTwo: string;
  @Input()
  // eslint-disable-next-line @typescript-eslint/naming-convention
  public personalGuideEligible: boolean;
  @Input()
  public type: WaitTimeTypes;
  @Input() public hasEnablePreChatWelcome: boolean;
}
